import api from '../../../../helpers/api';

export const getBigNumbers = (payload) => {
  return api.post(
    'developer/bloomberg/mvp-transactions/transactions-market',
    payload
  );
};

export const getMarkers = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/geo-locations',
    payload
  );
};

export const getBuildingDetails = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/detailed-info-window',
    payload
  );
};

export const getTransactionedOverExisting = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/transactioned-over-existing-realties',
    payload
  );
};

export const getTransactionsList = () => {
  return api.get('developer/bloomberg/transactioned-realties-metrics/list');
};

export const getAvaliableFilters = (cityId) => {
  return api.get(`developer/bloomberg/mvp-transactions/list/filters/${cityId}`);
};

export const getInfoWindow = (coordinates) => {
  return api.get(`developer/bloomberg/mvp-transactions/pin-info`, {
    params: {
      lat: coordinates?.lat,
      lon: coordinates?.long,
    },
  });
};
